import axios from 'axios';
import * as types from '../mutation-types';
import Cookies from 'js-cookie';

export const state = () => ({
    selectedShippingMethod: null,
    selectedPaymentMethod: null,
    selectedStore: null,
    deliveryCondition: null,
    stateType: 1,
    errors: null,
    authCheck: false,
    currency: false,
    numberOfDecimals: 0,
    totalFromVue: 0,
    totalWithoutSelections: 0,
    totalWithShipping: 0,
});

export const getters = {
    selectedShippingMethod: state => state.selectedShippingMethod,
    selectedPaymentMethod: state => state.selectedPaymentMethod,
    selectedStore: state => state.selectedStore,
    deliveryCondition: state => state.deliveryCondition,
    stateType: state => state.stateType,
    errors: state => state.errors,
    authCheck: state => state.authCheck,
    currency: state => state.currency,
    numberOfDecimals: state => state.numberOfDecimals,
    totalFromVue: state => state.totalFromVue,
    totalWithoutSelections: state => state.totalWithoutSelections,
    totalWithShipping: state => state.totalWithShipping,
    totalFromVueHtml: state => {
        let splitTotal = String(state.totalFromVue).split('.');
        if (splitTotal[1]) {
            let cents;
            if (splitTotal[1] < 10) {
                cents = splitTotal[1];
            } else {
                cents = splitTotal[1];
            }
            return splitTotal[0] + '<span class="dec-point">,</span>' + cents + state.currency;
        } else {
            if (isNaN(state.totalFromVue)) {
                return state.totalFromVue;
            } else {
                return state.totalFromVue + '<span class="dec-point">,</span>00' + state.currency;
            }
        }
    },
};

export const mutations = {
    [types.SET_SHIPPING_METHOD](state, deliveryMethod) {
        state.selectedShippingMethod = deliveryMethod;
    },
    [types.SET_PAYMENT_METHOD](state, paymentMethod) {
        state.selectedPaymentMethod = paymentMethod;
    },
    [types.SET_STORE](state, store) {
        state.selectedStore = store;
    },
    [types.RESET_PAYMENT_METHOD](state) {
        state.selectedPaymentMethod = null;
        Cookies.remove('eshop_payment_method');
    },
    [types.RESET_SHIPPING_CONDITION](state) {
        state.deliveryCondition = null;
        Cookies.remove('eshop_shipping_method');
    },
    [types.SET_SHIPPING_CONDITION](state, condition) {
        state.deliveryCondition = condition;
    },
    [types.SET_ERRORS](state, errors) {
        state.errors = errors;
    },
    [types.SET_AUTH_CHECK](state, authCheck) {
        state.authCheck = authCheck;
    },
    [types.SET_CURRENCY](state, currency) {
        state.currency = currency;
    },
    [types.SET_NUMBER_OF_DECIMALS](state, numberOfDecimals) {
        state.numberOfDecimals = numberOfDecimals;
    },
    [types.SET_TOTAL_FROM_VUE](state, totalFromVue) {
        state.totalFromVue = totalFromVue;
    },
    [types.SET_TOTAL_FROM_VUE_WITHOUT_SELECTIONS](state, totalWithoutSelections) {
        state.totalWithoutSelections = totalWithoutSelections;
    },
    [types.SET_TOTAL_WITH_SHIPPING](state, totalWithShipping) {
        state.totalWithShipping = totalWithShipping;
    },
};

export const actions = {
    async submitMethodSelectionForm({ state, commit }) {
        let form = new FormData();
        form.append('shipping_id', state.selectedShippingMethod);
        form.append('payment_id', state.selectedPaymentMethod);
        if (state.selectedStore) {
            form.append('store_id', state.selectedStore);
        }
        let url;
        if (state.authCheck) {
            url = '/order-selections';
        } else {
            url = '/order-method-selection-cookies';
        }
        await axios
            .post(url, form)
            .then(() => {
                commit(types.SET_SHIPPING_METHOD, state.selectedShippingMethod);
                commit(types.SET_PAYMENT_METHOD, state.selectedPaymentMethod);
                commit(types.SET_STORE, state.selectedStore);
            })
            .catch(e => {
                commit(types.SET_ERRORS, e.response.data.errors);
            });
    },
    async submitShippingMethod({ commit }, payload) {
        let form = new FormData();
        form.append('shipping_id', payload);
        form.append('_method', 'PUT');
        await axios
            .post('/order-delivery-method', form)
            .then(() => {
                commit(types.SET_SHIPPING_METHOD, payload);
            })
            .catch(e => {
                commit(types.SET_ERRORS, e.response.data.errors);
            });
    },
    async submitPaymentMethod({ commit }, payload) {
        let form = new FormData();
        form.append('payment_id', payload);
        form.append('_method', 'PUT');
        await axios
            .post('/order-payment-method', form)
            .then(() => {
                commit(types.SET_PAYMENT_METHOD, payload);
            })
            .catch(e => {
                commit(types.SET_ERRORS, e.response.data.errors);
            });
    },

    async deletePaymentMethod({ commit }) {
        let form = new FormData();
        form.append('_method', 'DELETE');
        await axios
            .delete('/order-payment-method', form)
            .then(() => {
                commit(types.RESET_PAYMENT_METHOD);
            })
            .catch(e => {
                commit(types.SET_ERRORS, e.response.data.errors);
            });
    },

    async submitStoreMethod({ commit }, payload) {
        let form = new FormData();
        form.append('store_id', payload);
        form.append('_method', 'PUT');
        await axios
            .post('/order-store-method', form)
            .then(() => {
                commit(types.SET_STORE, payload);
            })
            .catch(e => {
                commit(types.SET_ERRORS, e.response.data.errors);
            });
    },
};
